import { Component, Input } from '@angular/core';

import { BuildingBlockInterface } from '../building-block.interface';
import { ImageParagraphComponentContext } from './image-paragraph-context.interface';

@Component({
    templateUrl: './image-paragraph.component.html',
    styleUrls: ['./image-paragraph.component.min.css'],
})
export class ImageParagraphComponent implements BuildingBlockInterface {
    @Input() public context: ImageParagraphComponentContext;
    public paddingEnabled = true;
}



// WEBPACK FOOTER //
// /Users/tom/Projects/mercit2018/src/app/project/building-blocks/image-paragraph/image-paragraph.component.ts